import { render } from "./Sample.vue?vue&type=template&id=73e25d11&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"

import "./Sample.vue?vue&type=style&index=0&id=73e25d11&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e25d11"]])

export default __exports__